// GENERATED FILE - do not edit.
// Emitted by tools/generate-wire-schemas.mjs from
// Server/src/Shared/Server/Resources/openapi.json (the spec lockfile).
// Regenerate with: npm run generate:wire
//
// Base wire shape for the server "SnippetLocalisation" component. The corresponding
// *.schema.ts is the facade that names it (and hosts any future refinement);
// see design/wiki/wire-schemas.md.
import { z } from "zod";
import { LocalisationMode } from "./localisation-mode.enum.gen";

export const SnippetLocalisationGenShape = z.strictObject({
  libraryId: z.string(),
  parentId: z.string(),
  teamId: z.string(),
  data: z.string(),
  localisationMode: z.enum(LocalisationMode),
  id: z.string(),
});
